module.exports = __webpack_public_path__ + "public/img/chongzhibeifen.fc1379c2.png";